export default __webpack_public_path__ + "static/media/momopay.e935e1c4.png";